<template>
  <v-container
    class="mt-4"
    v-if="this.eventSchedule && this.eventSchedule.length > 0"
  >
    <v-layout>
      <schedule-list-view :events="events" v-if="listView">
      </schedule-list-view>
      <v-row v-else>
        <v-col>
          <v-card>
            <v-sheet height="64">
              <v-toolbar flat color="white">
                <v-btn
                  fab
                  text
                  small
                  color="grey darken-2"
                  :disabled="previousDisabled"
                  @click="previous"
                >
                  <v-icon small>mdi-chevron-left</v-icon>
                </v-btn>
                <v-toolbar-title>{{ title }}</v-toolbar-title>
                <v-btn
                  fab
                  text
                  small
                  color="grey darken-2"
                  :disabled="nextDisabled"
                  @click="next"
                >
                  <v-icon small>mdi-chevron-right</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  fab
                  text
                  small
                  color="grey darken-2"
                  @click="previousType"
                >
                  <v-icon small>mdi-chevron-left</v-icon>
                </v-btn>
                <v-toolbar-title>
                  {{ $t(type) }}
                </v-toolbar-title>
                <v-btn fab text small color="grey darken-2" @click="nextType">
                  <v-icon small>mdi-chevron-right</v-icon>
                </v-btn>
              </v-toolbar>
            </v-sheet>
            <v-sheet>
              <v-calendar
                ref="calendar"
                v-model="focus"
                :start="startDate"
                :end="endDate"
                :type="type"
                :first-interval="firstInterval"
                :interval-count="intervalCount"
                :interval-minutes="calendarInterval"
                :event-color="event => event.color || '#a21c26'"
                :events="eventSchedule"
                :short-intervals="false"
                :short-weekdays="false"
                :locale="eventLocale"
                :weekdays="weekdays"
                event-overlap-mode="column"
                @click:event="showEvent"
                @click:more="viewDay"
                @click:date="viewDay"
                @change="updateRange"
              >
                <template v-slot:event="eventProps">
                  <div class="v-event-summary pl-1">
                    <strong>{{
                      eventLocale === "de"
                        ? eventProps.event.title
                        : eventProps.event.title_en
                    }}</strong>
                  </div>
                </template>
              </v-calendar>
              <v-dialog
                v-model="selectedOpen"
                :activator="selectedElement"
                width="unset"
              >
                <event-detail
                  @close="selectedOpen = false"
                  :selectedEvent="selectedEvent"
                ></event-detail>
              </v-dialog>
            </v-sheet>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import * as moment from "moment";
import { i18n } from "../plugins/i18n";
import { eventScheduleResource } from "../api/resources";
import EventDetail from "./EventDetail.vue";
import ScheduleListView from "./ScheduleListView.vue";
import Vue from "vue";
import * as _ from "underscore";

export default {
  components: {
    EventDetail,
    ScheduleListView,
  },
  async created() {
    if (window.calendarInterval) {
      this.calendarInterval = +window.calendarInterval[this.widgetId];
    }
    if (window.listView) {
      this.listView = window.listView[this.widgetId] === "true";
    }
    if (window.showCustomEvents) {
      this.showCustomEvents = window.showCustomEvents[this.widgetId] === "true";
    }
  },
  props: ["widgetId"],
  data: () => ({
    focus: "",
    type: "day",
    start: null,
    end: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    listView: false,
    calendarInterval: 15,
    eventSchedule: [],
    events: [],
    showCustomEvents: false,
  }),
  async mounted() {
    moment.locale(this.eventLocale);

    if (this.showCustomEvents) {
      const customEvents = window.customEvents[this.widgetId]
        ? JSON.parse(window.customEvents[this.widgetId])
        : [];
      this.events = customEvents.map(event => ({
        ...event,
        name: this.eventLocale === "de" ? event.title : event.title_en,
        start: event.date + " " + event.startTime,
        end: event.date + " " + event.endTime,
      }));
    } else {
      await this.getEvents();
    }
    await this.calculateEventSchedule();
    this.type =
      window.innerWidth < 960 ? "day" : this.showWeekView ? "week" : "4day";
  },
  methods: {
    async getEvents() {
      const res = await eventScheduleResource.get("", {
        headers: {
          "x-xsrf-token": Vue.$cookies.get("oegg-cms.csrf"),
        },
      });
      this.events = res.data.results.map(event => ({
        ...event,
        name: this.eventLocale === "de" ? event.title : event.title_en,
        start: event.date + " " + event.startTime,
        end: event.date + " " + event.endTime,
      }));
    },
    async calculateEventSchedule() {
      const sortedResult = this.events
        .map(e => ({
          ...e,
          startMomentDate: moment(e.date + "T" + e.startTime),
          endMomentDate: moment(e.date + "T" + e.endTime),
        }))
        .sort((a, b) => a.startMomentDate.diff(moment(b.startMomentDate)));

      const groupBy = _.groupBy(sortedResult.filter(e => e.categoryId), e => e.categoryId);
      const groupedEvents = [];
      for (let key of Object.keys(groupBy)) {
        const events = groupBy[key];
        const sorted = events.sort((a, b) =>
          a.startMomentDate.diff(moment(b.startMomentDate))
        );

        const continuos = [[sorted[0]]];
        let currentGroup = 0;

        for (let i = 1; i < sorted.length; ++i) {
          const currentMatchingList = continuos[currentGroup];

          if (
            !currentMatchingList[
              currentMatchingList.length - 1
            ].endMomentDate.isSame(sorted[i].startMomentDate)
          ) {
            currentGroup++;
            continuos[currentGroup] = [];
          }
          continuos[currentGroup].push(sorted[i]);
        }

        const getCategoryData = events => {
          if (events.length > 0) {
            return {
              ...events[0]._category,
              room: events[0].room,
              date: events[0].date,
              startTime: events[0].startTime,
              endTime: events[events.length - 1].endTime,
              start: events[0].start,
              end: events[events.length - 1].end,
              events: events,
            };
          }
        };

        for (const list of continuos) {
          if (list.length > 0) {
            groupedEvents.push(getCategoryData(list));
          }
        }
      }
      const eventsWithoutCategory = sortedResult.filter(e => !e.categoryId);
      this.eventSchedule = groupedEvents.concat(eventsWithoutCategory);
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    previous() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    updateRange({ start, end }) {
      this.start = start.date;
      this.end = end.date;
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    nextType() {
      this.focus = this.startDate;
      if (this.showWeekView) {
        if (this.type === "day") {
          this.type = "4day";
        } else if (this.type === "4day") {
          this.type = "week";
        } else if (this.type === "week") {
          this.type = "day";
        }
      } else {
        this.type = this.type === "day" ? "4day" : "day";
      }
    },
    previousType() {
      this.focus = this.startDate;
      if (this.showWeekView) {
        if (this.type === "day") {
          this.type = "week";
        } else if (this.type === "4day") {
          this.type = "day";
        } else if (this.type === "week") {
          this.type = "4day";
        }
      } else {
        this.type = this.type === "day" ? "4day" : "day";
      }
    },
  },

  computed: {
    title() {
      if (this.type === "day") {
        return moment(this.start).format("LL");
      }
      return `${moment(this.start).format("LL")} - ${moment(this.end).format(
        "LL"
      )}`;
    },
    eventLocale() {
      return i18n.locale;
    },
    previousDisabled() {
      return !moment(this.startDate).isBefore(moment(this.start));
    },
    nextDisabled() {
      return !moment(this.endDate).isAfter(moment(this.end));
    },
    firstInterval() {
      const earliestEvent = this.eventSchedule.reduce((previous, current) => {
        const previousTime = moment(previous.startTime, "HH:mm");
        const currentTime = moment(current.startTime, "HH:mm");
        return previousTime.isBefore(currentTime) ? previous : current;
      });
      return (
        moment.duration(earliestEvent.startTime).asMinutes() /
          this.calendarInterval -
        1
      );
    },
    intervalCount() {
      const earliestEvent = this.eventSchedule.reduce((previous, current) => {
        const previousTime = moment(previous.startTime, "HH:mm");
        const currentTime = moment(current.startTime, "HH:mm");
        return previousTime.isBefore(currentTime) ? previous : current;
      });
      const latestEvent = this.eventSchedule.reduce((previous, current) => {
        const previousTime = moment(previous.endTime, "HH:mm");
        const currentTime = moment(current.endTime, "HH:mm");
        return previousTime.isAfter(currentTime) ? previous : current;
      });
      const durationMinutes = moment(latestEvent.endTime, "HH:mm").diff(
        moment(earliestEvent.startTime, "HH:mm"),
        "minutes"
      );
      return Math.ceil(durationMinutes / this.calendarInterval) + 2;
    },
    weekdays() {
      let weekdays = [];
      let startDay = parseInt(moment(this.startDate).format("e"));
      do {
        weekdays.push(startDay);
        ++startDay;
        if (startDay > 6) {
          startDay = 0;
        }
      } while (startDay !== weekdays[0]);
      return weekdays;
    },
    startDate() {
      const sortedDate = this.eventSchedule.map(entry => entry.date).sort();
      return sortedDate[0];
    },
    endDate() {
      const sortedDate = this.eventSchedule.map(entry => entry.date).sort();
      return sortedDate[sortedDate.length - 1];
    },
    showWeekView() {
      return moment(this.endDate).diff(moment(this.startDate), "days") >= 4;
    },
  },
};
</script>
<style lang="scss"></style>
